import { TFunction } from "i18next";
import { IAutoCompleteTrader } from "src/types/common";
import { getFullName } from "src/utils/user-name-util";
import { isDeletedUserStatus } from "src/utils/user-status-util";

interface IGetAutoCompleteTraderNameParams {
    trader: IAutoCompleteTrader;
    t: TFunction<"common">;
    separator?: string;
}

export const getAutoCompleteTraderName = ({ trader, t, separator = " · " }: IGetAutoCompleteTraderNameParams) => {
    if (isDeletedUserStatus(trader.userStatus)) {
        return t("user-deleted");
    }

    const fullName = getFullName(trader);
    return fullName ? `${fullName}${separator}${trader.nickName}` : trader.nickName;
};
